class PrkPhotoSwipeThumbnails {
  constructor(lightbox, options = { isMobile: false }) {
    this.lightbox = lightbox;
    this.options = options;
    this.thumbnailsContainer = null;
    this.thumbnails = [];
    this.prevIndex = -1;
    this.isMobile = this.options?.isMobile || false;
    this.init();
  }

  init() {
    this.lightbox.options.paddingFn = this.thumbnailsPaddingFn.bind(this);

    this.lightbox.on('uiRegister', () => {
      this.lightbox.pswp.ui.registerElement({
        name: 'PrkPhotoSwipeThumbnails',
        className: `prk-pswp-thumbnails ${this.isMobile ? 'prk-pswp-thumbnails--is-mobile' : ''}`,
        appendTo: 'wrapper',
        onInit: (el, pswp) => {
          this.thumbnailsContainer = el;
          this.createThumbnails(pswp);

          if (this.thumbnails.length < 2) {
            this.thumbnailsContainer.classList.add('prk-pswp-thumbnails--hidden');
          }

          // Add support for legacy scroll-bars
          if (!('scrollbarWidth' in document.documentElement.style)) {
            this.thumbnailsContainer.classList.add('prk-pswp-thumbnails--legacy-scrollbars');
          }
        }
      });
    });

    this.lightbox.on('change', () => {
      this.updateActiveThumbnail();
      this.scrollToActiveThumbnail();
    });

    this.lightbox.on('close', () => {
      this.thumbnailsContainer?.remove();
    });
  }

  createThumbnails(pswp) {
    this.thumbnails = [];
    this.thumbnailsContainer.innerHTML = '';
    let photoCount = 0;
    let videoCount = 0;

    for (let i = 0; i < pswp.getNumItems(); i++) {
      const thumbnail = document.createElement('img');
      thumbnail.className = 'prk-pswp-thumbnails__item';
      const itemData = pswp.getItemData(i);
      const { element, src, width, height, type } = itemData;
      const thumbSrc = itemData.msrc ?? element?.dataset?.pswpThumbSrc ?? undefined;
      const thumbWidth = itemData.thumbWidth ?? element?.dataset?.pswpThumbWidth ?? undefined;
      const thumbHeight = itemData.thumbHeight ?? element?.dataset?.pswpThumbHeight ?? undefined;
      const isVideo = ['prk-video', 'youtube'].includes(type);

      if (isVideo)
        videoCount++;
      else
        photoCount++;

      let alt = itemData.alt || element?.getAttribute('alt');
      if (!alt) {
        alt = isVideo
          ? `Видео ${videoCount}`
          : `Фото ${photoCount}`
      }

      thumbnail.src = thumbSrc || src;
      thumbnail.alt = alt;
      thumbnail.setAttribute('width', thumbWidth || width);
      thumbnail.setAttribute('height', thumbHeight || height);

      thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));

      this.thumbnailsContainer.appendChild(thumbnail);
      this.thumbnails.push(thumbnail);
    }

    this.updateActiveThumbnail();
  }

  updateActiveThumbnail() {
    if (!this.thumbnailsContainer || !this.lightbox.pswp) return;

    const currIndex = this.lightbox.pswp.currIndex;
    
    if (this.prevIndex >= 0 && this.thumbnails[this.prevIndex]) {
      this.thumbnails[this.prevIndex].classList.remove('prk-pswp-thumbnails__item--active');
    }
    
    if (this.thumbnails[currIndex]) {
      this.thumbnails[currIndex].classList.add('prk-pswp-thumbnails__item--active');
      this.prevIndex = currIndex;
    }
  }

  scrollToActiveThumbnail() {
    if (!this.thumbnailsContainer || this.prevIndex < 0) return;

    const activeThumb = this.thumbnails[this.prevIndex];
    if (!activeThumb) return;

    const container = this.thumbnailsContainer;
    const thumbRect = activeThumb.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    if (this.isMobile) {
      // Horizontal scrolling for mobile
      const containerWidth = container.clientWidth;
      const scrollLeft = thumbRect.left - containerRect.left - (containerWidth / 2) + (thumbRect.width / 2);
      
      container.scrollTo({
        left: container.scrollLeft + scrollLeft,
        behavior: 'smooth'
      });
    } else {
      // Vertical scrolling for desktop
      const containerHeight = container.clientHeight;
      const scrollTop = thumbRect.top - containerRect.top - (containerHeight / 2) + (thumbRect.height / 2);
      
      container.scrollTo({
        top: container.scrollTop + scrollTop,
        behavior: 'smooth'
      });
    }
  }

  onThumbnailClick(event) {
    event.preventDefault();
    this.lightbox.pswp.goTo(this.thumbnails.indexOf(event.currentTarget));
  }

  thumbnailsPaddingFn(viewportSize) {
    const defaultPadding = 15;

    if (this.isMobile) {
      const thumbnailsSidePadding = this.thumbnails.length > 1
        ? defaultPadding * 2 + 80
        : 0;

      return { 
        top: 0, 
        bottom: thumbnailsSidePadding,
        left: 0, 
        right: 0 
      };
    }

    const thumbnailsSidePadding = this.thumbnails.length > 1
      ? defaultPadding * 3 + 80
      : defaultPadding;

    return {
      top: defaultPadding,
      bottom: defaultPadding,
      left: thumbnailsSidePadding,
      right: defaultPadding
    };
  }
}

export { PrkPhotoSwipeThumbnails };
export default PrkPhotoSwipeThumbnails;
